import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getOrCreateTournamentConfig, updateTournamentConfig } from "./actions";

export const coreTournamentConfigEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity?.tournamentId,
});

const initialState = coreTournamentConfigEntityAdapter.getInitialState({});

export const coreTournamentConfigSlice = createSlice({
  name: "coreTournamentConfig",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getOrCreateTournamentConfig.fulfilled, (state, action) => {
      if (action.payload.statusCode === 200) {
        coreTournamentConfigEntityAdapter.setOne(state, action.payload.data);
      }
    });
    builder.addCase(updateTournamentConfig.fulfilled, (state, action) => {
      if (action.payload.statusCode === 200) {
        coreTournamentConfigEntityAdapter.upsertOne(state, action.payload.data);
      }
    });
  },
});

export default coreTournamentConfigSlice.reducer;
